import { GET_D2D_PILLS, GET_D2D_PILLS_DONE, GET_D2D_PILLS_ERR, RESET_PILLS, SOFT_RESET_PILLS } from './actionTypes';
export const getDayToDayPills = () => ({
    type: GET_D2D_PILLS
});
export const getDayToDayPillsDone = (data) => ({
    type: GET_D2D_PILLS_DONE,
    data
});
export const getDayToDayPillsError = (data) => ({
    type: GET_D2D_PILLS_ERR,
    errorMessage: data
});
export const resetPills = () => ({
    type: RESET_PILLS
});
export const softResetPills = () => ({ type: SOFT_RESET_PILLS });
//# sourceMappingURL=actionCreators.js.map